import { formatThousands } from '@/utils/helpers'

export default (price, slug, dictionary) => {
  let sign = ''

  if (dictionary.length) {
    const currency = dictionary.find(item => item.slug === slug)

    if (currency) {
      sign = currency.sign
    }
  }

  return `${formatThousands(Number(price))} ${sign}`.trim()
}